import React from 'react';
import './TimeOfDaySelector.css';

const TimeOfDaySelector = ({ selectedTime, onTimeChange }) => {
  const timeOptions = [
    { id: 'dawn', label: 'Dawn' },
    { id: 'day', label: 'Day' },
    { id: 'dusk', label: 'Dusk' },
    { id: 'night', label: 'Night' }
  ];

  return (
    <div className="time-of-day-selector">
      {timeOptions.map((option) => (
        <button
          key={option.id}
          className={`time-option ${selectedTime === option.id ? 'selected' : ''}`}
          onClick={() => onTimeChange(option.id)}
          data-time={option.id}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};

export default TimeOfDaySelector;
